module.exports = __webpack_public_path__ + "img/mallikuva1.7f7f2792.jpg";